module.exports = __webpack_public_path__ + "img/dan1.87f7151e.png";